export class AddCPUBenchmarkRequest  {
    CPUName: string;
    BenchmarkScore: number;
}
